import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { RootState } from '@/models/index';
import Tag from '../tag';
import styles from './index.module.scss';

interface IButtonProps {
  list: { name: string; id: string | number; type: string }[];
  onChange: (ids, id?, type?) => any;
  fieldNames?: { label: string; value: string; type?: string };
  width?: number;
  minWidth?: number;
  defaultValue?: any;
  className?: any;
  children?: any;
  allItem?: {
    allName: string;
    allType: string;
  };
  otherClick?: any;
  onClick?: any;
  isSingle?: boolean;
}

export default function TagList({
  list,
  onChange,
  fieldNames,
  width,
  defaultValue,
  minWidth,
  className,
  children,
  allItem,
  onClick,
  otherClick,
  isSingle,
}: IButtonProps) {
  if (fieldNames) {
    list = list?.map(item => ({
      ...item,
      id: item[fieldNames.label],
      name: item[fieldNames.value],
      type: item[fieldNames.type],
    }));
  }
  const [selectedId, setSelectedId] = useState([]);
  const [allSelected, setAllSelected] = useState(!!allItem?.allName);
  const dispatch = useDispatch();
  const { hasOtherCity } = useSelector<RootState, RootState['brand']>(state => state.brand);
  useEffect(() => {
    setSelectedId(defaultValue ? defaultValue : []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [showMore, setShowMore] = useState(false);
  const handleClick = item => {
    if (selectedId.indexOf(item.id) > -1) {
      setSelectedId(selectedId.filter(unit => unit !== item.id));
      onChange(
        list.filter(block => selectedId.filter(unit => unit !== item.id).indexOf(block.id) > -1),
        [item.id]
      );
    } else {
      if (isSingle) {
        setSelectedId([item.id]);
        onChange(
          list.filter(block => item.id === block.id),
          [item.id],
          allItem?.allType
        );
      } else {
        setSelectedId([...selectedId, item.id]);
        onChange(list.filter(block => [...selectedId, item.id].indexOf(block.id) > -1));
      }
    }
  };
  const tagRef = useRef();
  useEffect(() => {
    if ((tagRef?.current as any).offsetHeight > 136) {
      setShowMore(true);
    }
  }, []);
  useEffect(() => {
    setAllSelected(selectedId.length === 0);
  }, [selectedId]);
  useEffect(() => {
    !showMore && document.getElementById(`${selectedId}`)?.click();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMore]);
  return (
    <>
      <div className={showMore ? styles.moreHeight : ''}>
        <div
          className={classNames(
            'flex-row-wrap',
            'flex-start-center',
            'tag-list-content',
            styles.tagList,
            `${className}`
          )}
          ref={tagRef}
        >
          {allItem?.allName && (
            <Tag
              width={width}
              minWidth={minWidth}
              name={allItem?.allName}
              id={'-1'}
              data-class="all_type_class"
              onClick={() => {
                if (!allSelected) {
                  setAllSelected(true);
                  onChange([], selectedId, allItem?.allType);
                  setSelectedId([]);
                  dispatch({ type: 'brand/setHasOtherCity', payload: false });
                }
              }}
              selected={allSelected}
            ></Tag>
          )}
          {list?.map(item => (
            <Tag
              width={width}
              minWidth={minWidth}
              name={item.name}
              id={item.id}
              key={item.id}
              onClick={() => {
                onClick ? onClick(item) : handleClick(item);
              }}
              selected={selectedId.indexOf(item.id) > -1}
            ></Tag>
          ))}
          {otherClick && (
            <Tag
              width={60}
              name={'其他'}
              id={'2'}
              selected={hasOtherCity}
              onClick={() => {
                setAllSelected(false);
                otherClick();
              }}
            ></Tag>
          )}
          {children}
        </div>
      </div>
      {showMore && (
        <div
          className={styles.loadMore}
          onClick={() => {
            setShowMore(false);
          }}
        >
          展示更多
          <svg className="icon" aria-hidden="true">
            <use xlinkHref="#icon-keyboard_arrow_down"></use>
          </svg>
        </div>
      )}
    </>
  );
}
